import Vue from 'vue'
import Vuetify from 'vuetify'
import Router from 'vue-router'
import App from './App'
import firebase from 'firebase'
import Dash from '@/views/Dash'
import Login from '@/views/Login'
import Register from '@/views/Register'
import store from './store'

Vue.use(Vuetify)
Vue.config.productionTip = false

Vue.use(Router)

const routes = [{
  path: '/login',
  component: Login
},
{
  path: '/register',
  component: Register
},
{
  path: '/',
  name: 'dash',
  component: Dash,
  beforeEnter: (to, from, next) => {
    if (!firebase.auth().currentUser) {
      next('/login')
    } else {
      next()
    }
  }
}]
const router = new Router({
  routes
})

let config = {
  apiKey: 'AIzaSyDlCH-GK15VxcaZlNZH8xSmH5Rvkp4MRtQ',
  authDomain: 'qikbits-bd394.firebaseapp.com',
  databaseURL: 'https://qikbits-bd394.firebaseio.com',
  projectId: 'qikbits-bd394',
  storageBucket: 'qikbits-bd394.appspot.com',
  messagingSenderId: '690805498548'
}

firebase.initializeApp(config)

window.firebase = firebase

/* eslint-disable no-new */
const unsuscribe = firebase.auth().onAuthStateChanged(user => {
  store.dispatch('setUser', user)
  new Vue({
    el: '#app',
    template: '<App/>',
    components: {
      App
    },
    router,
    store
  })
  unsuscribe()
})



// WEBPACK FOOTER //
// ./src/main.js